import * as React from 'react';
import { FC } from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';
import { Box } from '@rbilabs/components-library/build/components/layout';

import ActionButton from 'components/action-button';

import { ContentContainer, ModalBody, ModalHeading, StyledDialog, StyledGearIcon } from './styles';
import { IGeolocationPermissionModalViewProps } from './types';

export const GeolocationPermissionModalView: FC<IGeolocationPermissionModalViewProps> = ({
  isOpen,
  dismissModal,
  openSettings,
  modalBodyText,
  modalHeadingText,
  openSettingsButtonText,
  flowTestId,
}) => {
  if (!isOpen) {
    return null;
  }
  return (
    <StyledDialog
      data-testid={`geolocation-${flowTestId}-modal`}
      heading={
        <ModalHeading data-testid={`geolocation-${flowTestId}-heading`}>
          {modalHeadingText}
        </ModalHeading>
      }
      bodyComponent={
        <ContentContainer data-testid={`geolocation-${flowTestId}-body`}>
          <StyledGearIcon>
            <Icon icon="settings" color="icon-default" width="24px" aria-hidden />
          </StyledGearIcon>
          <ModalBody>{modalBodyText}</ModalBody>
        </ContentContainer>
      }
      actions={
        openSettings && (
          <Box margin="1rem" minWidth="auto" width="100%">
            <ActionButton
              fullWidth
              onlyIcon
              data-testid={`geolocation-${flowTestId}-open-settings`}
              onClick={openSettings}
            >
              {openSettingsButtonText}
            </ActionButton>
          </Box>
        )
      }
      modalAppearanceEventMessage={`Previously ${flowTestId} Location Services Modal`}
      showCloseButton
      onDismiss={dismissModal}
    />
  );
};

export default GeolocationPermissionModalView;
